import {
  Controller,
  FieldValues,
  UseFormGetFieldState,
  useFormContext,
} from "react-hook-form";
import { TFormularioDynSpecProps } from "../../types/api/bpm/detalhar-processo";
import React from "react";
import DynSelect from "./InputsDyn/DynSelect";
import DynTextField from "./InputsDyn/DynTextField";
import DynAttachment from "./InputsDyn/DynAttachment";
import DynDate from "./InputsDyn/DynDate";
import DynInfoContabeis from "./FormsDyn/DynInfoContabeis";
import DynRateio from "./FormsDyn/DynRateio";
import DynRetencao from "./FormsDyn/DynRetencao";
import DynAnaliseDoc from "./FormsDyn/DynAnaliseDoc";
import { TContaCorrente } from "../../types/api/financeiro/conta-corrente";
import DynRemoverTituloApGlobal from "./FormsDyn/DynRemoverTituloApGlobal";
import DynCotaCapital from "./FormsDyn/DynCotaCapital";
import DynDadosCadastrais from "./FormsDyn/DynDadosCadastrais";
import DynDadosPropriedade from "./FormsDyn/DynDadosPropriedade";
import DynInserirNumeroMatricula from "./FormsDyn/DynInserirNumeroMatricula";
import { Typography } from "@mui/material";
import DynDadosAnalise from "./FormsDyn/DynDadosAnalise";

export default function DynamicFormHandler({
  spec,
  extras,
}: DynamicFormHandlerProps) {
  const { control, getFieldState } = useFormContext();

  const InputRender = (field: FieldValues) => {
    if (spec.type === "info_text")
      return <Typography variant="body2" color="error">{spec.label}</Typography>;
    if (spec.type === "select")
      return <DynSelect {...{ spec, getFieldState, field }} />;
    if (spec.type === "text")
      return <DynTextField {...{ spec, getFieldState, field }} />;
    if (spec.type === "file")
      return <DynAttachment {...{ spec, getFieldState, field }} />;
    if (spec.type === "date")
      return <DynDate {...{ spec, getFieldState, field }} />;

    if (spec.type === "form_aplicar_rateio")
      return <DynRateio {...{ spec, extras }} />;
    if (spec.type === "form_adicionar_retencao")
      return <DynRetencao {...{ spec, extras }} />;
    if (spec.type === "form_informacoes_contabeis")
      return <DynInfoContabeis {...{ spec, extras }} />;
    if (spec.type === "form_analise_documentacao")
      return <DynAnaliseDoc {...{ spec, extras }} />;
    if (spec.type === "form_remover_titulo_ap_global")
      return <DynRemoverTituloApGlobal {...{ spec, extras }} />;
    if (spec.type === "form_dados_propriedade")
      return <DynDadosPropriedade {...{ spec }} />;
    if (spec.type === "form_dados_cadastrais")
      return <DynDadosCadastrais {...{ spec, extras }} />;
    if (spec.type === "form_inserir_numero_matricula")
      return <DynInserirNumeroMatricula {...{ spec, extras }} />;
    if (spec.type === "form_cota_capital")
      return <DynCotaCapital {...{ spec }} />;
    if (spec.type === "form_tipo_operacao_analise_credito")
      return <DynDadosAnalise {...{ spec }} />;

    return <React.Fragment />;
  };

  return (
    <Controller
      name={spec.name}
      control={control}
      rules={{ required: spec.required }}
      render={({ field }) => <InputRender {...{ field }} />}
    />
  );
}

export interface DynamicFormHandlerProps {
  spec: TFormularioDynSpecProps;
  extras: any | null;
}

export interface DynInputProps {
  field: FieldValues;
  spec: TFormularioDynSpecProps;
  getFieldState: UseFormGetFieldState<FieldValues>;
}
export interface DynFormProps {
  spec: TFormularioDynSpecProps;
}

export interface Documento {
  tipo_publico: string;
  codigo_publico: string;
  tipo_documento_id: string;
  numero_documento: number;
  serie_documento: string;
  data_emissao: string;
  data_vencimento: string;
  valor_total: number;
  is_parcelado: string;
  parcelas: Array<string>;
  justificativa: string;
  conta_bancaria: TContaCorrente;
}

export interface TParcela {
  valor: number;
  numero_parcela: number;
  data_vencimento: string;
}

